module.exports = __webpack_public_path__ + "static/monkey_1024-40-c7b071d9b8723a5a8a9911a9673f76d8.jpg";